<style lang="less">
    @import "./main.less";
</style>

<template>
	<div class="main">
		
		
		<!-- 子元素 -->
    	<div class="page">
    		<router-view></router-view>
    	</div>
	</div>
</template>

<script>
	import util from './../util'
	export default{
		name:'main',
		data(){
			return{
				active:'install',
				type:''
			}
		},
		created () {
			console.log(this.$route.path)
			if(this.$route.path!='/f'){
				this.$router.push({
	                path: 'home',
	                query: {type:'cc',type:window.location.hash.split('type=')[1]}
	            });
			}
		},
		methods:{
			handleMenu(name){
				this.$router.push({
                    path: 'home',
                    query: {cate:name,type:window.location.hash.split('type=')[1]}
                });
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/Main.vue